/**
 * src/gm/platform/locks.ts — 跨标签页互斥（Web Locks API）。
 *
 * 同一名称的锁在全 origin 范围内互斥，名字带项目 id 域，保证同一项目的唤醒认领 /
 * 结算 / 启动恢复在任意两个标签页之间串行。拿不到锁（ifAvailable 立即返回 null）
 * 给玩家明确提示。
 *
 * 无 navigator.locks 的环境（Node 测试、非安全上下文）退化为直接执行——
 * 唤醒队列持久化与脏标记幂等仍然兜底。
 */

import { GmError } from './errors'

export async function withProjectLock<T>(name: string, fn: () => Promise<T>): Promise<T> {
  if (typeof navigator === 'undefined' || !navigator.locks) {
    return fn()
  }
  const result = await navigator.locks.request(name, { ifAvailable: true }, (lock) => {
    if (!lock) {
      throw new GmError(
        'BAD_STATUS',
        '另一个标签页正在操作这个项目——去那边完成，或等它忙完再来。',
        { lock: name },
      )
    }
    return fn()
  })
  return result as T
}

/** 唤醒认领锁名（开工/开发/验收/上架/放弃/恢复共用同一项目域） */
export function gmLockName(projectId: string): string {
  return `tp3:gm:${projectId}`
}

/** 结算锁名（settle 独立加锁，防恢复路径与正常路径跨页并发双结算） */
export function settleLockName(projectId: string): string {
  return `tp3:settle:${projectId}`
}
